import "stylesheets/components/common/CustomCheckbox.css"; // TODO old css file
import React from "react";
import PropTypes from "prop-types";
import clientErrorLogger from "util/clientErrorLogger";
import CustomError from "./CustomError";
import FormField from "../../mixins/FormField";
import autobind from "autobind-decorator";
import isFunction from "lodash/isFunction";

class CustomCheckbox extends React.Component {
    static propTypes = {
        label: PropTypes.node.isRequired,
        onChange: PropTypes.func
    };

    static defaultProps = {
        inConverter: value => value
    };

    static defaultProps = {
        inConverter: value => value
    };

    static defaultProps = {
        inConverter: value => value
    };

    constructor() {
        super();
    }

    // adapted from FormField.handleChange
    @autobind
    handleCheckboxChange(e) {
        if (!this.inputElement) {
            clientErrorLogger.notify("No input element defined for form field", "error");
            return;
        }

        this.value = this.inputElement.checked;
        this.updateBackingValue(false);

        if (isFunction(this.props.onChange)) {
            this.props.onChange(e);
        }
    }

    render() {
        const {
            fieldName,
            label,
            id,
            name
        } = this.props;
        const checkboxId = id || "chk-" + fieldName;
        return (
            <div className={this.getClassNames("custom-checkbox-container")}>
                <input id={checkboxId}
                    className="custom-checkbox"
                    type="checkbox"
                    name={name || fieldName}
                    ref={this.setInputRef}
                    value={fieldName}
                    checked={this.readValue()}
                    onChange={this.handleCheckboxChange}
                    {...this.getInnerInputProps()}
                />
                <label htmlFor={checkboxId} className="custom-checkbox-label">{label}</label>
                <CustomError errors={this.getErrors()} />
            </div>
        );
    }
}

// FormField makes this an observer
export default FormField(CustomCheckbox);
